import { useQuery, useMutation } from "react-query";
import { useSelector } from "react-redux";
import { customAPI } from "../services/api";

let totalCount = 0;
const getGroupItem = (id) =>
  customAPI.get("api/Groups/" + id).then((res) => {
    return res;
  });
const createGroup = (data, token) => {
  return customAPI(token).post("api/Groups", data);
};

const editGroup = (id, data, token) => {
  return customAPI(token).put("api/Groups/" + id, data);
};
const deleteGroup = (id, data, token) => {
  return customAPI(token).delete("api/Groups/" + id);
};

const useManageGroup = ({ id = null }) => {
  const { token } = useSelector((store) => store.auth);

  const { data: detail } = useQuery(
    `GET-GROUP-ITEM-${id}`,
    () => getGroupItem(id),
    {
      enabled: !!id,
    }
  );

  const createMutation = useMutation((data) => createGroup(data, token), {
    onError: (error) => {
      if (error.response.status == 409) {
        error.message = "Duplicate Group entry exists";
        return error;
      } else {
        error.message = "Something went wrong";
        return error;
      }
    },
  });

  const updateMutation = useMutation((data) => editGroup(id, data, token));
  const deleteMutation = useMutation((data) => deleteGroup(id, data, token));

  return {
    totalCount: totalCount,
    detail,
    deleteMutation,
    createMutation,
    updateMutation,
  };
};

export default useManageGroup;
